import React, { CSSProperties, useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import AssetAllocation from './AssetAllocation';
import SectorBreakdown from './SectorBreakdown';
import CountryBreakdown from './CountryBreakdown';
import RegionalBreakdown from './RegionalBreakdown';
import Tab from 'components/Base/Tabs/Tab';

const BreakdownTabContent = ({ selectedInvestment }: any) => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTab(newValue);
  };

  const tabProps = (index: any) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
      style: {
        borderBottom: '2px solid #eaeaea',
        textTransform: 'none'
      } as CSSProperties
    };
  };

  const components = [
    AssetAllocation,
    SectorBreakdown,
    CountryBreakdown,
    RegionalBreakdown
  ] as any;

  const CurrentComponent = components[tab];

  return (
    <div style={{ paddingTop: '2rem' }}>
      <Tabs
        style={{ marginBottom: '1rem' }}
        value={tab}
        onChange={handleTabChange}
        TabIndicatorProps={{
          style: { display: 'none' }
        }}
      >
        <Tab label="Asset Class" {...tabProps(0)} />
        <Tab label="Sector" {...tabProps(1)} />
        <Tab label="Country" {...tabProps(2)} />
        <Tab label="Regional" {...tabProps(3)} />
      </Tabs>

      <CurrentComponent selectedInvestment={selectedInvestment} />
    </div>
  );
};

export default BreakdownTabContent;
